import { Avatar, Divider, ListItemText, Stack, MenuItem, ListItemIcon, MenuList, Menu, ListItem, Box, useTheme } from "@mui/material";
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import AuthContext from "../Contexts/AuthenticationContext";
import { useContext, useState } from "react";
import { Link } from "react-router";
import Text from "../../genericComponents/Text";

const MenuAccountBar = ({ avatarMenuItems }) => {
  const { logout, user } = useContext(AuthContext);
  const theme = useTheme()
  const account = user ? user : { name: 'Admin' }
  const [anchorEl, setAnchorEl] = useState()
  const handleClick = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  return (<Stack direction="column">
      <Divider />
      <MenuList>
        <MenuItem onClick={handleClick}
          key={account.id}
          component="button"
          sx={{
            justifyContent: 'flex-start',
            width: '100%',
            columnGap: 2,
          }}
        >
          <ListItemIcon>
            <Avatar
              sx={{
                width: 32,
                height: 32,
                bgcolor: account.color,
              }}
              src={account.picture ?? ''}
              alt={account.picture ?? ''}
            >
              ED
            </Avatar>
          </ListItemIcon>
          <ListItemText
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              width: '100%',
            }}
            primary={"Energy Department"}
            secondary={""}
          />
        </MenuItem>
      </MenuList>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {avatarMenuItems
          ? avatarMenuItems.map((menuItem, index) =>{
            const Icon=menuItem.icon;
            return (
            <ListItem
              stlye={{
                display: 'flex',
                alignItems: 'center',
                padding: theme.spacing(1),
                textDecoration: 'none'
              }}
              key={index}
              onClick={() => {
                handleClose()
              }}
              component={Link}
              to={menuItem.path}
            >
              <Box sx={(theme) => ({ color: theme.palette.secondary.main, paddingRight: theme.spacing(1) })}>
                <Icon/>
              </Box>
              <Text text={menuItem.text} />
            </ListItem>
          )})
          : null}
        <ListItem
          onClick={() => logout({ returnTo: window.location.origin })}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(1),
            textDecoration: 'none'
          }}>
          <Box sx={(theme) => ({ color: theme.palette.secondary.main, paddingRight: theme.spacing(1) })}>
            <ExitToAppIcon />
          </Box>
          <Text text={"i18n_logout"} />
        </ListItem>
      </Menu>
      <Divider />
    </Stack>
  );
}
export default MenuAccountBar;